//import Libraries
import React, {Component} from 'react';

// import Components
import { Collapse, Row, Col, Input,  Button } from 'reactstrap'
import Product from './Product/Product';
import UpDownTransitionArrow from '../../../../components/UpDownTransitionArrow/UpDownTransitionArrow';

//import Styles
import './Category.css'

class NotClassifiedCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse : false,
        }
    } 

    toggle = () => {
        this.setState(prevState => ({
            collapse : !prevState.collapse
        }))
    }

    render(){
        const {name, products} = this.props;

        return (
            <div className="category">
                <div className="main-category">
                    <Row onClick={this.toggle}>
                        <Col className="title" xs="11"><h5>{name}</h5></Col>
                        <Col xs="1">
                            <UpDownTransitionArrow up={this.state.collapse} handleOnClick={this.toggle}/>
                        </Col>
                    </Row>
                </div>
                <Collapse isOpen={this.state.collapse}>
                {
                    products && products.map((product, index) => {
                        return (
                            <Product
                                makeEditAnything={this.props.makeEditAnything}
                                makeEditDoneAnything={this.props.makeEditDoneAnything}
                                editCategory={true}
                                product={product}
                                key={index}
                            />
                        );
                    })
                }
                </Collapse>
            </div>
        );
    }
}

export default NotClassifiedCategory ;


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/NotClassifiedCategory.js